import { useCallback, useState } from "react";
import { openNativeLivoraCallShell } from "../plugins/NativeLivoraCall";
import "./NativeShellTestButton.css";

export default function NativeShellTestButton() {
  const [busy, setBusy] = useState(false);

  const handleOpenShell = useCallback(async () => {
    if (busy) {
      return;
    }

    setBusy(true);
    try {
      const result = await openNativeLivoraCallShell();
      console.log("[nativeShellTest] result", result);
    } catch (error) {
      console.log("[nativeShellTest] error", String(error?.message || error));
    } finally {
      setBusy(false);
    }
  }, [busy]);

  return (
    <button
      type="button"
      className="native-shell-test-btn"
      onClick={handleOpenShell}
      disabled={busy}
      aria-label="Open Native Shell test"
    >
      Open Native Shell
    </button>
  );
}
